import * as FullStory from '@fullstory/browser';
import * as cdLogger from 'services/cdLogger';

const initFullStory = ({ fullStoryOrgId }) => {
  try {
    if (!fullStoryOrgId) throw new Error('FullStory ID Missing');

    FullStory.init({ orgId: fullStoryOrgId });
  } catch (err) {
    cdLogger.error(err);
  }
};

export default initFullStory;
